export default (settings: any) => settings['filters'] * (1 / 60) * 20
